<template>
  <div
    class="container-fluid d-flex flex-wrap banking main-wrapper"
    style="background: #202020; height: 100vh; overflow-y: scroll; background-size: cover; background-attachment: fixed; padding-bottom: 15rem;"
  >
    <div
      class="col-12 p-0 mb-5"
      style="height: 110vh;"
    >
      <div class="bg-transparent">
        <div class="pl-2 pt-3 bg-transparent">
          <div class="align-items-center">
            <div class="col-8">
              <h3 class="mb-0 text-white">
                {{ $t('banking.bank_info') }}
              </h3>
            </div>
          </div>
        </div>

        <div
          class="error text-center py-2"
          v-if="error"
        >
          <span>{{ error }}</span>
        </div>

        <div class="card-body bg-transparent">
          <form @submit.prevent="updateBankInfo">
            <div class="mt-3 row">
              <!-- Bank Username -->
              <div class="col-lg-12">
                <div class="form-group">
                  <label class="form-control-label text-white">
                    {{ $t('banking.bank_username') }}
                  </label>
                  <input
                    type="text"
                    class="form-control custom-input"
                    v-model="account.name"
                  />
                  <span
                    class="text-danger"
                    v-if="errors?.name"
                  >{{ errors.name }}</span>
                </div>
              </div>

              <!-- Bank Account Number -->
              <div class="col-lg-12">
                <div class="form-group">
                  <label class="form-control-label text-white">
                    {{ $t('banking.bank_number') }}
                  </label>
                  <input
                    type="number"
                    class="form-control custom-input"
                    v-model="account.account_number"
                  />
                  <span
                    class="text-danger"
                    v-if="errors?.number"
                  >{{ errors.number }}</span>
                </div>
              </div>

              <!-- Bank Type Select -->
              <div class="col-lg-12">
                <div class="form-group">
                  <label class="form-control-label text-white">
                    {{ $t('banking.bank_type') }}
                  </label>
                  <AccountSelect
                    :data="account"
                    field="type"
                    :accounts="accounts"
                  />
                  <span class="text-danger">{{ errors.account }}</span>
                </div>
              </div>

              <!-- Submit Button -->
              <div class="form-group col-12 mt-2">
                <button
                  type="submit"
                  class="btn btn-primary custom-btn"
                  :disabled="isConfirm"
                >
                  <template v-if="!isConfirm">
                    {{ $t('banking.submit') }}
                  </template>
                  <Loading
                    v-else
                    color="#ffffff"
                    size="24"
                    class="px-4 py-0"
                  />
                </button>
              </div>

              <!-- Note -->
              <div class="col-12">
                <h3
                  class="text-muted"
                  style="font-size: 1rem;"
                >
                  ** {{ $t('banking.note') }} **
                </h3>
                <span
                  class="text-muted"
                  style="font-size: 0.9rem;"
                >
                  {{ $t('banking.note_content') }}
                </span>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Toast, Loading } from 'vant';
import { mapActions } from 'vuex';
import AccountSelect from './components/AccountSelect.vue';

export default {
  components: {
    AccountSelect,
    Loading
  },
  data() {
    return {
      account: {
        name: '',
        account_number: '',
        type: null
      },
      accounts: [
        {
          name: 'KBZ Pay',
          id: 'KBZ Pay',
          link: 'https://cdn.gold549.com/build/assets/img/payments/kpay.png',
        },
        {
          name: 'KBZ Mobile Banking',
          id: 'KBZ Mobile Banking',
          link: 'https://cdn.gold549.com/build/assets/img/payments/kbz.png',
        },
        {
          name: 'Wave Pay',
          id: 'Wave Pay',
          link: 'https://cdn.gold549.com/build/assets/img/payments/wavepay.png',
        },
      ],
      error: null,
      errors: {},
      isConfirm: false,
    };
  },
  methods: {
    ...mapActions(['fetchUser']),

    async fetchBankInfo() {
      try {
        const res = await axios.get('/user_bank', {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`,
          },
        });
        console.log("RES BANK", res)
        // this.account = res.data.data;
        this.account = res.data.data || {
          name: '',
          account_number: '',
          type: null
        };

      } catch (error) {
        console.error(error);
      }
    },

    async updateBankInfo() {
      this.error = null;
      this.errors = {};

      if (!this.account.type) {
        this.error = this.$store.state.language === 'en'
          ? 'Please pick account type'
          : 'အကောင့်အမျိုးအစား ရွေးချယ်ပေးပါ။';
        return;
      }
      if (!this.account.account_number) {
        this.error = this.$store.state.language === 'en'
          ? 'Please enter account number'
          : 'အကောင့်နံပါတ် ထည့်သွင်းပေးပါ။';
        return;
      }
      if (!this.account.name) {
        this.error = this.$store.state.language === 'en'
          ? 'Please enter bank username'
          : 'Please enter bank username';
        return;
      }

      this.isConfirm = true;

      try {
        await axios.put('/user_bank', this.account, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`,
          },
        });

        Toast.success('Success');
        this.error = null;
      } catch (error) {
        this.error = error?.response?.data?.message || 'An error occurred.';
        this.errors = error?.response?.data?.errors || {};
      } finally {
        this.isConfirm = false;
      }
    }
  },
  async mounted() {
    const authUser = await this.fetchUser();
    if (!authUser) {
      return this.$router.push('/auth/login');
    }
    await this.fetchBankInfo();
  },
};
</script>
<style scoped>
.error {
  margin-bottom: 0;
  /* height: 40px; */
  display: flex;
  align-items: center;
  color: black;
  border: 1px solid rgb(255, 0, 0);
  border-radius: 8px;
  padding: 0px 15px;
  margin-top: 2rem;
  background: transparent;
  /* font-weight: bold; */
}

.custom-btn {
  /* background: #FFFCFC !important; */
  background: #000000 !important;
  border: 1px solid #FBE78E !important;
  box-shadow: none !important;
  color: white !important;
  font-weight: 600;
  font-size: 1rem;
  width: 100% !important;
  /* border-radius: 25px; */
  height: 40px !important;
}

.custom-input,
.custom-input:active,
.custom-input:focus {
  /* background: transparent !important; */
  color: white !important;
  background-color: #000000 !important;
  border: 1px solid #24221E !important;
  border-radius: .5rem;
  text-align: center;
  /* height: 50px; */
  font-size: 1.3rem;
  font-weight: 300;
  box-shadow: none;
}

.image-container {
  width: 200px;
  height: 200px;
}

.image-container img {
  width: 100%;
  height: 100%;
  border-radius: 5px;
}

.number-container {
  border-radius: 5px;
  background: #e9ecef;
  justify-content: center;
}

.custom-file {
  height: auto;
}

/* @media (max-width: 768px) { */
.main-wrapper {
  padding: 7px !important;
}

/* } */
</style>
